
export const JOB_STATUS_VALUES = ["open", "hold", "closed/lost", "closed/won"] as const;

export interface JobFormData {
  title: string;
  companyId: string;
  companyName: string;
  description: string;
  aiSummary: string;
  skills: string;
  contactId?: string;
  
  // New field
  status: string;
  // New field for closing reason
  closing_reason?: string;
  // Fields
  employmentType: string;
  timeCommitment: string; // Added separate time commitment field
  contractDuration: string;
  startDate: string;
  endDate: string;
  seniorityLevel: string;
  budget: string;
  budgetFreelance: string;
  locationType: string;
  workplaceBreakdown: string;
  hardSkills: string;
  softSkills: string;
  educationLevel: string;
  yearsOfExperience: string;
  languageRequirements: string;
  extraLang: string;
  cultureTags: string;
  applicationDeadline: string;
  jobPostingDate: string;
  source: string;
  assignedRecruiter: string;
  employmentClassification: string;
  notes?: string;
}

export interface JobDetail {
  id: string;
  title: string;
  company: {
    id: string;
    name: string;
  };
  description?: string;
  aiSummary?: string;
  skills: string[];
  contactId?: string;
  
  // New field
  status?: string;
  // Fields
  employmentType?: string;
  timeCommitment?: string; // Added separate time commitment field
  contractDuration?: string;
  startDate?: string;
  endDate?: string;
  seniorityLevel?: string;
  budget?: string;
  budgetFreelance?: string;
  locationType?: string;
  workplaceBreakdown?: string;
  hardSkills?: string[];
  softSkills?: string[];
  educationLevel?: string;
  yearsOfExperience?: string;
  languageRequirements?: string;
  extraLang?: string;
  cultureTags?: string[];
  applicationDeadline?: string;
  jobPostingDate?: string;
  source?: string;
  assignedRecruiter?: string;
  employmentClassification?: string;
  notes?: string; // Added notes property
}

// Employment types (removed Full-time and Part-time)
export const EMPLOYMENT_TYPES = ["Contract", "Freelance", "Temporary", "Internship"];

// Time commitment options
export const TIME_COMMITMENTS = ["Full-time", "Part-time"];
